/**
 * Normaliza URLs de plataformas de vídeo para o formato embed com autoplay.
 * Suporta YouTube (watch, youtu.be, embed) e Vimeo.
 * URLs desconhecidas são retornadas sem alteração.
 */
export function normalizeEmbedUrl(url: string): string {
  try {
    const u = new URL(url)
    const host = u.hostname.replace(/^www\./, '')

    // YouTube: youtube.com/watch?v=ID
    if (host === 'youtube.com' && u.pathname === '/watch') {
      const v = u.searchParams.get('v')
      if (v) return buildYouTubeEmbed(v)
    }

    // YouTube: youtu.be/ID
    if (host === 'youtu.be') {
      const v = u.pathname.slice(1).split('?')[0]
      if (v) return buildYouTubeEmbed(v)
    }

    // YouTube: já é embed — re-aplica params de autoplay
    if (host === 'youtube.com' && u.pathname.startsWith('/embed/')) {
      const v = u.pathname.split('/')[2]
      if (v) return buildYouTubeEmbed(v)
    }

    // Vimeo: vimeo.com/ID
    if (host === 'vimeo.com') {
      const match = u.pathname.match(/^\/(\d+)/)
      if (match) return buildVimeoEmbed(match[1])
    }

    // Vimeo: já é player — re-aplica params de autoplay
    if (host === 'player.vimeo.com') {
      const match = u.pathname.match(/^\/video\/(\d+)/)
      if (match) return buildVimeoEmbed(match[1])
    }

    return url
  } catch {
    return url
  }
}

function buildYouTubeEmbed(videoId: string): string {
  const params = new URLSearchParams({
    autoplay: '1',
    mute: '1',
    controls: '0', // esconde barra de controles
    disablekb: '1', // impede teclado de reativar controles
    iv_load_policy: '3', // esconde anotações
    loop: '1',
    playlist: videoId, // necessário para loop funcionar
    rel: '0',
    modestbranding: '1',
    playsinline: '1'
  })
  return `https://www.youtube.com/embed/${videoId}?${params.toString()}`
}

function buildVimeoEmbed(videoId: string): string {
  const params = new URLSearchParams({
    autoplay: '1',
    muted: '1',
    loop: '1',
    background: '1' // esconde controles no Vimeo
  })
  return `https://player.vimeo.com/video/${videoId}?${params.toString()}`
}
